import { __awaiter, __generator } from "tslib";
import { useCallback } from 'react';
export var useLogErrorBoundary = function () {
    return useCallback(function (error, errorInfo, eventName) { return __awaiter(void 0, void 0, void 0, function () {
        var stack, params, _a, logError, logDiagnostic, logDebugCacheEvent;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    stack = (_b = error.stack) !== null && _b !== void 0 ? _b : '';
                    params = {
                        ComponentStack: (_c = errorInfo.componentStack) !== null && _c !== void 0 ? _c : '',
                        Message: error.message,
                        DebugInfo: stack,
                    };
                    return [4 /*yield*/, import('@office-start/telemetry-service')];
                case 1:
                    _a = _d.sent(), logError = _a.logError, logDiagnostic = _a.logDiagnostic;
                    return [4 /*yield*/, import('@office-start/instrumentation-service')];
                case 2:
                    logDebugCacheEvent = (_d.sent()).logDebugCacheEvent;
                    logError({
                        eventName: eventName,
                        message: error.message,
                        debugInfo: error.stack,
                    });
                    logDiagnostic({
                        eventName: eventName,
                        params: params,
                    });
                    logDebugCacheEvent(eventName, params);
                    return [2 /*return*/];
            }
        });
    }); }, []);
};
//# sourceMappingURL=useLogErrorBoundary.js.map